import type { HomeShowcaseListType } from './helper';
import { HomeShowcaseItem } from './HomeShowcaseItem';

type Props = {
  list: HomeShowcaseListType;
  selectedShowcase?: HomeShowcaseListType[number];
  onClickShowcase: (showcase: HomeShowcaseListType[number]) => void;
};

export function VerticalShowcaseList({
  list,
  selectedShowcase,
  onClickShowcase,
}: Props) {
  return (
    <div className="relative h-[inherit] shrink-0 basis-[76px]">
      <div className="absolute inset-0 flex flex-col gap-8 overflow-y-auto overflow-x-hidden">
        {list.map((item, index) => {
          return (
            <HomeShowcaseItem
              showcase={item}
              key={item.adGroupId}
              onClick={() => onClickShowcase(item)}
              selected={item.adGroupId === selectedShowcase?.adGroupId}
              index={index + 1}
            />
          );
        })}
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-[-1px] z-10 h-32 bg-[linear-gradient(to_top,#ffffff,transparent)]" />
    </div>
  );
}
